import $ from 'jquery';
import nunjucks from 'nunjucks';
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();
import ShareBox from './sharebox';
import settings from '../settings';

export default class Trends
{
    constructor(liveposts)
    {
        this.$buttons = $('.content-box--trending-selection');
        this.$tabs = $('.tabs.trending ul li a');
        this.$trends = $('.trends');

        this.$buttons.on('click', this.click__trend_select.bind(this));
        this.$tabs.parents('.tabs').on('tab__switch', this.switch__tab.bind(this));
        this.$trends.on('click', '.trend__share', this.click__trend__share.bind(this));
        $('.trend-selection__toggle').on('click', this.click__trend__toggle.bind(this));

        this.sharebox = new ShareBox();

        this.mPostsCache = new Map();

        this.liveposts = liveposts;

        this.discover();
    }

    /**
     * Holds a cache of post objects
     * This way we can reference them later without trying
     * to grab what's on the page
     */
    addPostsToCache(posts) {
        posts.forEach((post) => this.mPostsCache.set(Number(post.id), post));
    }

    getPostFromCache(postid) {
        postid = Number(postid);
        let item = this.mPostsCache.get(postid);
        if (!item) throw new Error('Post '+postid+' not found in post cache');
        return item;
    }

    discover()
    {
        let urls = [
                '/trends/all?filter=clicks',
                '/trends/all?filter=reach',
                '/trends/all?filter=shares'
            ],
            deferreds = urls.map((url) =>
                $.ajax({
        			headers   : settings.api_headers,
        			url       : url,
        			type      : 'GET',
        			dataType  : 'json'
            	})
            );
        $.when(...deferreds).done((...results) => {
            let posts = results.map((r) => r[0].posts),
                refresh = true;

            for (let arrPosts of posts) {
                if (0 == arrPosts.length) {
                    this.hideSelf();
                    refresh = false;
                }
            }

            if (refresh) {
                this.refresh();
            }
        })
    }

    hideSelf()
    {
        $('.content-box--trending, .trend-selection').hide();
    }

    refresh()
    {
		// get correct url here
        let type = $('.tabs.trending ul li.is-active').data('type'),
            filter = $('.content-box--trending-selection.active').data('selection');

        $.ajax({
			headers   : settings.api_headers,
			url       : '/trends/'+type+'?filter='+filter,
			type      : 'GET',
			dataType  : 'json'
    	})
    	.done((data) => {
            this.addPostsToCache(data.posts);
            this.liveposts.ignorePosts(data.posts);
            $('.trends').html(nunjucksEnv.render('html/ui/trends.html', data));
        });
    }

    click__trend_select(ev)
    {
        ev.preventDefault();

        let $me = $(ev.currentTarget);

        const img = $me.find('img').attr('src');
        const title = $me.data('title');

        $('.trend-selection__img').find('img').attr('src', img);
        $('.trend-selection__label').text(title);

        $('.trend-selection__options').hide();

        this.$buttons.removeClass('active');
        $me.addClass('active');

        // do something here
        this.refresh();
    }

    switch__tab(ev)
    {
        this.refresh();
    }

    click__trend__share(ev)
    {
        ev.preventDefault();

        var $me = $(ev.currentTarget),
            $my_trend = $me.parents('.trends__trend'),
            post_id = $my_trend.data('id'),
            objPost = this.getPostFromCache(post_id),
            strPost = objPost.post,
            images = objPost.images;

        this.sharebox.create(strPost, post_id, false, images);
    }

    click__trend__toggle(ev)
    {
      ev.preventDefault();

      $('.trend-selection__options').toggle();
    }
}
